import React from 'react'

import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'
import { KinerjaTipeProvider } from 'app/KinerjaShared/components/KinerjaTipeProvider'
import { DaftarPerilakuKerja } from 'app/KinerjaGpkPage/pages/pegawai/perencanaan/DaftarPerilakuKerja'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    _context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const enabled = toggle?.['kinerja-spnf-enabled'] || false

    if (!enabled) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }

    return { props: {} }
  },
})

const PanduanPerilakuKerja = () => {
  return (
    <KinerjaTipeProvider tipe="SPNF">
      <DaftarPerilakuKerja />
    </KinerjaTipeProvider>
  )
}

PanduanPerilakuKerja.Layout = KinerjaLayout

PanduanPerilakuKerja.layoutOpts = {
  hasHeader: true,
}

export default PanduanPerilakuKerja
